import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import DressCard from './DressCard';
import QuickView from './QuickView';
import { CREAM } from '../theme';

export default function CategoryListingView({ category, imageUrl }) {
  const [quickViewSlug, setQuickViewSlug] = useState(null);
  const dresses = (category.dresses || []).slice().sort((a, b) => a.order - b.order);
  const quickViewDress = dresses.find((d) => d.slug === quickViewSlug);
  const quickViewRef = useRef(null);

  useEffect(() => {
    if (quickViewDress && quickViewRef.current) {
      // Scroll to just above the panel rather than flush with the viewport
      // top — flush would tuck its heading behind the sticky nav bar.
      const top = quickViewRef.current.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, [quickViewDress]);

  return (
    <div>
      <section style={{ padding: 'clamp(48px,7vh,80px) clamp(36px,7vw,130px) clamp(24px,4vh,40px)' }}>
        <nav aria-label="Breadcrumb" style={{ fontSize: 13, letterSpacing: '.14em', textTransform: 'uppercase', color: 'rgba(239,228,210,.55)', marginBottom: 16 }}>
          <Link to="/#categories" style={{ color: 'inherit', textDecoration: 'none' }}>Home</Link>
          <span aria-hidden="true" style={{ fontSize: 18, margin: '0 8px' }}>›</span>
          <Link to="/categories" style={{ color: 'inherit', textDecoration: 'none' }}>Categories</Link>
          <span aria-hidden="true" style={{ fontSize: 18, margin: '0 8px' }}>›</span>
          <span aria-current="page" style={{ color: CREAM }}>{category.name}</span>
        </nav>
        <h1 style={{ fontFamily: "'Bodoni Moda', serif", fontStyle: 'italic', fontWeight: 500, fontSize: 'clamp(38px,5.4vw,64px)', margin: '0 0 16px', color: CREAM }}>{category.name}</h1>
        {category.description && (
          <p style={{ fontSize: 17, lineHeight: 1.7, color: 'rgba(239,228,210,.75)', maxWidth: 640 }}>{category.description}</p>
        )}
      </section>

      <section style={{ padding: '0 clamp(36px,7vw,130px) clamp(60px,9vh,100px)' }}>
        {dresses.length === 0 ? (
          <p style={{ color: 'rgba(239,228,210,.55)' }}>No pieces in this category yet.</p>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 250px), 1fr))', gap: 'clamp(24px,3vw,40px)' }}>
            {dresses.map((dress) => (
              <DressCard key={dress.slug} dress={dress} categorySlug={category.slug} imageUrl={imageUrl} onQuickView={setQuickViewSlug} />
            ))}
          </div>
        )}

        {quickViewDress && (
          <div ref={quickViewRef}>
            <QuickView dress={quickViewDress} categorySlug={category.slug} imageUrl={imageUrl} onClose={() => setQuickViewSlug(null)} />
          </div>
        )}
      </section>
    </div>
  );
}
